export enum FormTypes {
  Inform = 'inform',
  Sponsor = 'sponsor',
  Distributive = 'distributive',
  Filmmaking = 'filmmaking',
  Question = 'question',
  Scenario = 'scenario',
}

export enum DepartmentTypes {
  Sales = 'sales',
  Pr = 'pr',
  Hr = 'hr',
  Marketing = 'marketing',
  Purchases = 'purchases',
  Production = 'production',
  Finance = 'finance',
  Lawyers = 'lawyers',
  Security = 'security',
}
